(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deco-homepage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const homes = document.querySelectorAll('[data-deco-home]');
    homes.forEach((home) => {
      const track = home.querySelector('[data-deco-products]');
      const dots = [...home.querySelectorAll('[data-deco-dot]')];
      if (!track || dots.length === 0) return;
      let frame;
      const update = () => {
        frame = null;
        const cards = [...track.querySelectorAll('[data-deco-product-card]')];
        if (cards.length === 0) return;
        const trackLeft = track.getBoundingClientRect().left;
        let active = 0;
        let distance = Number.POSITIVE_INFINITY;
        cards.forEach((card, index) => {
          const current = Math.abs(card.getBoundingClientRect().left - trackLeft);
          if (current < distance) {
            distance = current;
            active = index;
          }
        });
        dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));
      };
      track.addEventListener('scroll', () => {
        if (frame) return;
        frame = requestAnimationFrame(update);
      }, { passive: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
